import React from 'react';
import PropTypes from 'prop-types';

import {translate} from 'views/module';

import {JsonTextField} from '../AgentJobDraftFields';
import {formatJson, parseJson} from '../../agentJobTypeUtils';

const UnknownAgentJobDraft = (props) => {
  const {
    payloadJsonText,
    setPayloadJsonText,
  } = props;

  return (
    <JsonTextField
      label={translate('case.Detail.AgentJobs.Fields.Payload')}
      onChange={setPayloadJsonText}
      value={payloadJsonText}
    />
  );
};

UnknownAgentJobDraft.propTypes = {
  payloadJsonText: PropTypes.string,
  setPayloadJsonText: PropTypes.func.isRequired,
};

const buildPayload = ({payloadJsonText}) => {
  return parseJson(payloadJsonText, translate('case.Detail.AgentJobs.Fields.Payload'));
};

const getDraftBody = (job) => formatJson(job.actionPayload || {});

const getListDetail = (job, participantDetails, executeAtLabel) => executeAtLabel;

export default {
  Draft: React.memo(UnknownAgentJobDraft),
  buildPayload,
  getDraftBody,
  getListDetail,
  label: translate('case.Detail.AgentJobs.UnknownAction'),
};
